// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntd[data-v-78a859db] \n{\n\tvertical-align: middle;\n}\n.table th[data-v-78a859db] \n{\n\tvertical-align: middle;\n}\n.icon.is-expanded[data-v-78a859db] \n{\n\t-webkit-transform: rotate(90deg);\n\t        transform: rotate(90deg)\n}\n.strike[data-v-78a859db] {\n\ttext-decoration: line-through;\n}\n", ""]);
// Exports
module.exports = exports;
